export default __webpack_public_path__ + "static/media/xplenty.97d085ba.webp";